const __request = require(`./__request/__request_contentType_json`);

// 编辑广告信息：http://tour-beta.yinzhilv.com/doc.html#/yinzhilv_travel/advert-controller/updateAdvertByIdUsingPOST
const web_common_advert_updateAdvertById = (pParameter) => {
    if (!pParameter) pParameter = {};
    const p = {
        method: 'post',
        urlSuffix: '/web/common/advert/updateAdvertById',
        data: pParameter
    };
    return new Promise(function(resolve, reject) {
        resolve(__request(p))
    })
};
module.exports = web_common_advert_updateAdvertById;